<div class="mt-3 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6 items-center">
    <ng-content></ng-content>
</div>